import { render, staticRenderFns } from "./OnboardingPhone.vue?vue&type=template&id=f77bf47c&"
import script from "./OnboardingPhone.vue?vue&type=script&lang=js&"
export * from "./OnboardingPhone.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPhone.vue?vue&type=style&index=0&id=f77bf47c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports